<!--
 * @Author: FengXiao
 * @Date: 2020-07-02 15:09:29
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-02 21:35:16
-->
<template>
  <div class="tab-zhiya-page page-container">
    <div class="banner-bl">
      <div class="banner-content">
        <span class="banner-title">一席枝桠</span>
      </div>
    </div>
    <div class="zhiya-bl content">
      <div class="zhiya-item" v-for="(item, index) in dataList" :key="item.id" @click="gotoDetail(item.id, item.videos[0].id)">
        <div class="zhiya_cover">
          <img class="zhiya_cover-img" :src="item.cover" :alt="item.speaker && item.speaker.name" srcset="" />
        </div>
        <div class="zhiya_info">
          <div class="zhiya_top">
			  <div class="zhiya_title">{{ item.speaker && item.speaker.name }}</div>
		  </div>
          <div class="zhiya_subtitle">{{ item.speaker && item.speaker.intro }}</div>
          <swiper class="swiper" :options="swiperOptions(index)" :ref="`${item.id}Swiper`">
            <swiper-slide v-for="(video, i) in item.videos" :key="video.id">
              <div class="video-item" @click.stop="gotoDetail(item.id, video.id)">
                <i class="iconfont iconplay2"></i>
                <span class="video_title">
                  <span class="video_no">{{ (i + 1) | formatIndex }}{{ video.title }}</span>
                </span>
                <span class="video_time">{{ video.time }}</span>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btns" v-if="item.videos.length > 3">
            <div class="swiper-btn-prev swiper-btn" :class="`swiper-${index}`" @click.stop>
              <i class="iconfont iconarrow-up"></i>
            </div>
            <div class="swiper-btn-next swiper-btn" :class="`swiper-${index}`" @click.stop>
              <i class="iconfont iconarrow-down"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';

const SWIPER_PAGE_SIZE = 3;
export default {
  data() {
    return {
      total: 0,
      // 分页
      pageNum: 1,
      pageSize: 4,
      dataList: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path !== '/zhiya/detail' || !vm.dataList.length) {
        vm.refreshData();
        vm.initScrollTop();
      }
    });
  },
  filters: {
    formatIndex(i) {
      return i < 10 ? `0${i}` : i;
    },
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  methods: {
    refreshData() {
      this.pageNum = 1;
      this.getData();
    },
    getData() {
      requestApi('/v3/api/site/zhiya/extend/', {
        page: this.pageNum,
        page_size: this.pageSize,
      }).then(({ items, total }) => {
        if (this.pageNum === 1) {
          this.dataList = items;
          this.total = total;
        } else {
          this.dataList.push(...items);
        }
      });
    },
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    gotoDetail(id, episodeId) {
      this.$router.push({
        path: '/zhiya/detail',
        query: {
          id,
          episodeId,
        },
      });
    },
    swiperOptions(index) {
      const obj = {
        direction: 'vertical',
        slidesPerView: SWIPER_PAGE_SIZE,
        slidesPerGroup: SWIPER_PAGE_SIZE,
        spaceBetween: 12,
        navigation: {
          prevEl: `.swiper-btn-prev.swiper-${index}`,
          nextEl: `.swiper-btn-next.swiper-${index}`,
        },
      };
      return obj;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-zhiya-page {
  .banner-bl {
    height: 260px;
    width: 100%;
    background: url('../assets/imgs/speech-bg.jpg') no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    box-sizing: border-box;
    .banner-content {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      max-width: 1140px;
      color: $C1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .banner-title {
        font-size: 47px;
        margin: 0;
        line-height: 1.5;
        letter-spacing: 3px;
        font-family: HYXinRenWenSongW;
      }
    }
  }
  .zhiya-bl {
    .zhiya-item {
      width: 100%;
      height: 285px;
      background: $C1;
      display: flex;
      margin: 40px 0;
      cursor: pointer;
      position: relative;
      border: 1px solid $C11;
      .zhiya_cover {
        width: 410px;
        height: 100%;
      }
      .zhiya_info {
        flex: 1;
        position: relative;
        padding: 20px;
		.zhiya_top {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
        .zhiya_title {
          font-family: HYXinRenWenSongW;
          color: $C6;
          margin: 10px 0 8px;
          letter-spacing: 0;
          font-size: 24px;
          line-height: 24px;
        }
        .zhiya_subtitle {
          font-size: 14px;
          line-height: 14px;
          color: $C12;
          font-weight: 300;
          margin-bottom: 14px;
        }
        .swiper {
          height: 150px;
        }
        .video-item {
          display: flex;
          align-items: center;
          background: $C10;
          padding: 12px 10px 12px 26px;
          box-sizing: border-box;
          .iconfont {
            color: $C2;
            font-size: 15px;
          }
          .video_title {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: $C3;
            // line-height: 14px;
            margin-left: 12px;
			display: flex;
			align-items: center;
            flex: 1;
          }
		  .video_no {
			  max-width: calc(100% - 90px);
		  }
          .video_time {
            color: $C9;
            font-size: 12px;
            font-weight: 200;
            font-family: Avenir-Book;
          }
        }
      }
    }
  }
}
</style>
